import React from 'react'
import { ManageTPLScales } from "../../modules/eMPower/pages/ManageTPLScales/CustomersPage";
export function ManageTPLScalesPage() {
    return (
        <ManageTPLScales/>
    )
}
